module.exports = __webpack_public_path__ + "static/media/Vortex-2WD-OV-3400.6487a2c7.png";